module.exports = __webpack_public_path__ + "img/React-TodoApp-desktop.cfdea0bd.jpg";